import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {PatientDataModel} from '../../models/patient/patient-data.model';

@Component({
  standalone: false,
  selector: 'app-patient-halt-dialog',
  templateUrl: './patient-halt-dialog.component.html',
  styleUrls: ['./patient-halt-dialog.component.scss']
})
export class PatientHaltDialogComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: PatientDataModel, private dialogRef: MatDialogRef<PatientHaltDialogComponent>) { }

  ngOnInit(): void {
  }

  onCancelClick() {
    this.dialogRef.close(false);
  }

  onOkClick() {
    this.dialogRef.close(true);
  }
}
